import React from 'react';

import {TooltipContent} from 'comp/tooltip';

export default class DismissableTooltip extends React.Component {
  constructor() {
    super();

    this.state = {dismissed: false};

    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss() {
    this.setState({dismissed: true});
  }

  render() {
    if (!this.props.visible || this.state.dismissed) {
      return null;
    } else {
      return <TooltipContent {...this.props} onDismiss={this.handleDismiss} />;
    }
  }
}

DismissableTooltip.propTypes = {
  visible: React.PropTypes.bool,
};

DismissableTooltip.defaultProps = {
  visible: true,
};



// WEBPACK FOOTER //
// ./src/ui/components/dismissable-tooltip.jsx